import React from 'react';
import { notification } from 'antd';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Enums from 'utils/EnumsManager';
import FieldFilterModal from './FieldFilterModal';
import styles from '../index.less';

const { TABLEMAXROWS } = Enums;

const cx = classNames.bind(styles);

const propTypes = {
  objectType: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  fetchObjectAllFields: PropTypes.func.isRequired,
  searchLayout: PropTypes.array.isRequired,
  addToSelection: PropTypes.func.isRequired,
  updateModuleColumnsByType: PropTypes.func.isRequired,
  selectedFields: PropTypes.array.isRequired,
  isDefaultField: PropTypes.bool,
  resetFilterValue: PropTypes.func.isRequired,
  fetchObjectSelectedField: PropTypes.func,
  needRestore: PropTypes.bool,
};
const defaultProps = {
  isDefaultField: false,
  needRestore: true,
  fetchObjectSelectedField: () => {}
};

class SearchFieldFilter extends React.Component {
  onModalOpen = () => {
    const {
      objectType,
      fetchObjectAllFields,
      searchLayout,
      addToSelection,
      fetchObjectSelectedField
    } = this.props;
    fetchObjectAllFields(objectType);
    fetchObjectSelectedField(objectType);
    if (_.isArray(searchLayout)) {
      addToSelection(searchLayout);
    }
  }

  onModalOk = cb => {
    const { objectType, updateModuleColumnsByType, selectedFields, intl } = this.props;
    const { formatMessage } = intl;

    const selectedFieldsId = _.isArray(selectedFields) ? selectedFields.map(f => f.id) : [];
    if (selectedFieldsId.length <= TABLEMAXROWS) {
      updateModuleColumnsByType(objectType, selectedFieldsId, cb);
    } else {
      notification.error({
        duration: 3,
        message: formatMessage({ id: 'page.FieldFilterModal.maxRowsError' }),
      });
    }
  }

  onModalRestore = cb => {
    const { updateModuleColumnsByType, objectType } = this.props;
    // to restore the setting, backend needs an empty arrary.
    updateModuleColumnsByType(objectType, [], cb);
  }

  onModalClose = () => this.props.resetFilterValue();

  render() {
    const {
      theme,
      objectType,
      isDefaultField,
      needRestore
    } = this.props;

    return (
      <FieldFilterModal
        theme={theme}
        code={objectType}
        customPanelBtn={cx('search-panel-actionBtn')}
        onModalOpen={this.onModalOpen}
        onModalOk={this.onModalOk}
        onModalRestore={this.onModalRestore}
        onModalClose={this.onModalClose}
        NeedRestriction
        isDefaultField={isDefaultField}
        needRestore={needRestore}
      />
    );
  }
}

SearchFieldFilter.propTypes = propTypes;
SearchFieldFilter.defaultProps = defaultProps;

export default injectIntl(SearchFieldFilter);



// WEBPACK FOOTER //
// ./src/components/page/FieldFilterModal/component/SearchFieldFilter.jsx